import {IRegisterExtendedWithoutMarketing} from "../types/IRegisterExtendedWithoutMarketing";

export const registerFormExtendedWithoutMarketingValues: IRegisterExtendedWithoutMarketing = {
    name: "",
    email: "",
    phone: {code: 48, number: ""}
};
import {IRegisterExtendedWithoutMarketing} from "../types/IRegisterExtendedWithoutMarketing";

export const registerFormExtendedWithoutMarketingValues: IRegisterExtendedWithoutMarketing = {
    name: "",
    email: "",
    phone: {code: 48, number: ""}
};
